declare const __HUDDLECO_REVIEW_MODE__: boolean;
declare const __HUDDLECO_REVIEW_EMAIL__: string;
declare const __HUDDLECO_REVIEW_PASSWORD__: string;

export const isReviewMode = typeof __HUDDLECO_REVIEW_MODE__ !== "undefined" && __HUDDLECO_REVIEW_MODE__;

export const visibleReviewCredentials = isReviewMode ? {
  email: __HUDDLECO_REVIEW_EMAIL__,
  password: __HUDDLECO_REVIEW_PASSWORD__,
} : null;
